<template>
  <div class="box">
    <!-- 顶部导航 -->
    <NavHeader :title="orderInfo.statementStatus" />
    <div class="flex1 bg-table-header p-a-10  flex-column overflow-auto" ref="scrollContent" @scroll="scrollContent">
      <div class="bg-table-header p-tb-10">
        <PayCountdown :isScroll="isScroll" v-if="!isPaySuccess" :toCancelSecond="toCancelSecond">
          <template #text>
            <span>
              待支付金额：
              <span class="text-danger font-weight-bold">¥{{ orderInfo.noSettleCurr }}</span>
            </span>
          </template>
          <template #btn>
            <el-button type="warning" round @click="toPay">去支付</el-button>
          </template>
        </PayCountdown>
      </div>
      <!-- 待支付卡片 -->
      <!-- <PayCard /> -->

      <!-- 对账单信息 + 汇总表格 -->
      <BillInfo :orderInfo="orderInfo" />

      <!-- 应收单据 -->
      <ReceivableSection :orderInfo="orderInfo" />

      <!-- 商品明细 -->
      <GoodsSection :purchaseNo="orderInfo.purchaseNo" :purchaseId="Number(id)" />

      <!-- 支付明细 -->
      <PayDetailSection :purchaseNo="orderInfo.purchaseNo" />
      <div class="m-t-10 bg-white p-a-20 flex flex-col-end">
        <div style="width:350px">
          <div class="flex flex-row-center m-b-10">
            <span class="inline-block w-100 text-right m-r-20">对账单号</span>
            <span class="flex1 text-right">
              <span>{{ orderInfo.purchaseNo }}</span> |
              <el-button type="text" style="padding: 0;" @click="copyFn(orderInfo.purchaseNo)">复制</el-button>
            </span>
          </div>
          <div class="flex flex-row-center m-b-10">
            <span class="inline-block w-100 text-right m-r-20">业务期间</span>
            <span class="flex1 text-right">{{ orderInfo.statementPeriod }}</span>
          </div>
          <template v-if="['待支付', '待对方支付'].includes(orderInfo.statementStatus)">
            <div class="flex flex-row-center m-b-10">
              <span class="inline-block w-100 text-right m-r-20">预结算日期</span>
              <span class="flex1 text-right">{{ orderInfo.preClearingDate }}</span>
            </div>
            <div class="flex flex-row-center m-b-10">
              <span class="inline-block w-100 text-right m-r-20">应结金额</span>
              <span class="flex1 text-right">￥{{ orderInfo.arrear }}</span>
            </div>
            <div class="flex flex-row-center m-b-10">
              <span class="inline-block w-100 text-right m-r-20">优惠金额</span>
              <span class="flex1 text-right">￥{{ orderInfo.discountAmount }}</span>
            </div>
            <div class="flex flex-row-center m-b-10">
              <span class="inline-block w-100 text-right m-r-20">已付金额</span>
              <span class="flex1 text-right">￥{{ orderInfo.settleCurr }}</span>
            </div>
            <div class="flex flex-row-center">
              <span class="inline-block w-100 text-right m-r-20">待支付金额</span>
              <span class="flex1 text-right font-size-20 font-weight-bold text-danger">
                ￥{{ orderInfo.noSettleCurr }}
              </span>
            </div>
          </template>
          <template v-if="orderInfo.statementStatus === '已完成'">
            <div class="flex flex-row-center m-b-10">
              <span class="inline-block w-100 text-right m-r-20">支付时间</span>
              <span class="flex1 text-right">{{ orderInfo.lastSettleDate }}</span>
            </div>
            <div class="flex flex-row-center m-b-10">
              <span class="inline-block w-100 text-right m-r-20">应结金额</span>
              <span class="flex1 text-right">￥{{ orderInfo.arrear }}</span>
            </div>
            <div class="flex flex-row-center m-b-10">
              <span class="inline-block w-100 text-right m-r-20">优惠金额</span>
              <span class="flex1 text-right">￥{{ orderInfo.discountAmount }}</span>
            </div>
            <div class="flex flex-row-center m-b-10">
              <span class="inline-block w-100 text-right m-r-20">已付金额</span>
              <span class="flex1 text-right">￥{{ orderInfo.settleCurr }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="bg-white p-a-10 text-right border-top-1" v-if="orderInfo.statementStatus === '待支付'">
      <!-- <el-button type="primary" size="small">
        分享(F2)
      </el-button>
      <el-button type="primary" size="small">
        打印(F4)
      </el-button>
      <el-button type="primary" size="small">
        导出(O/Alt+O)
      </el-button> -->
      <el-button type="primary" size="small" @click="toPay">
        结算(F7)
      </el-button>
    </div>
  </div>
</template>
<script>
import NavHeader from "./components/NavHeader.vue";
// import PayCard from "./components/PayCard.vue";
import BillInfo from "./components/BillInfo.vue";
import ReceivableSection from "./components/ReceivableSection.vue";
import GoodsSection from "./components/GoodsSection.vue";
import PayDetailSection from "./components/PayDetailSection.vue";
import PayCountdown from "./components/PayCountdown.vue";
import { statementDetails } from "@/api/reconciliation";
export default {
  name: "PayReconciliation",
  components: {
    PayCountdown,
    NavHeader,
    // PayCard,
    BillInfo,
    ReceivableSection,
    GoodsSection,
    PayDetailSection
  },
  data() {
    return {
      isScroll: false,
      isPaySuccess: false,
      toCancelSecond: true,
      orderInfo: {},
      id: 0
    };
  },
  mounted() {
    const query = this.$route.query;
    console.log("query", query);
    this.id = query.id;
    this.getDetails();
  },
  methods: {
    toPay() {
      let path = "";
      if (this.$route.path.includes("/new-products/system-center/wl-reconciliation")) {
        path = "/new-products/system-center/wl-reconciliation/pay";
      } else {
        path = "/reconciliations/statementPay";
      }
      this.$router.push({
        path: path,
        query: { id: this.id }
      });
    },
    getDetails() {
      statementDetails(this.id).then(res => {
        console.log("details", res);
        this.orderInfo = res;
        this.isPaySuccess = this.orderInfo.statementStatus !== "待支付";
      });
    },
    copyFn(text) {
      this.$copyText(text).then(
        () => {
          this.$message.success("复制成功！");
        },
        () => {
          this.$message.error("复制失败");
        }
      );
    },
    scrollContent(e) {
      if (e.target.scrollTop > 130) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
    },
    toPayFn() {
      this.$refs.scrollContent.scrollTop = 2000;
    }
  }
};
</script>
<style scoped>
.box {
  height: 100%;
  overflow-y: scroll;
}
</style>
